export const enum DXFSymbol {
  Section = 'SECTION',
  EOF = 'EOF',

  //Start markers
  Block = 'BLOCK', //start of block
  Table = 'TABLE', //start of table
  Class = 'CLASS', //start of class

  //End markers
  EndSec = 'ENDSEC', //end of section
  EndBlk = 'ENDBLK', //end of block
  EndTable = 'ENDTAB', //end of table
  SeqEnd = 'SEQEND', //end of sequence

  //SECTION types:
  Header = 'HEADER',
  Tables = 'TABLES',
  Blocks = 'BLOCKS',
  Entities = 'ENTITIES', //Also see EntityName enum defined in './entities/geometry'
  Classes = 'CLASSES',
  Objects = 'OBJECTS',

  //Symbol table types:
  LType = 'LTYPE',
  Layer = 'LAYER',
  VPort = 'VPORT',
  Style = 'STYLE',

  //currently unhandled Symbol table types
  AppId = 'APPID',
  BlockRecord = 'BLOCK_RECORD',
  DimStyle = 'DIMSTYLE',
  UCS = 'UCS',
  View = 'VIEW',

  //currently unhandled SECTION type
  ThumbnailImage = 'THUMBNAILIMAGE',
}
